export default "__VITE_ASSET__D9ins7Jb__"